// This File is to allow for support with the new TL syntax, please keep this up to date as keys.txt changes,
// or if we want to update the text on a string
// we have a tool will that builds a legacyi18nObject using this mapping
// the tool is buildLegacyI18n in @bingads-webui-campaign/smart-i18n
// this file isn't exported, because we don't want the _TL_ syntax visible in the main exported code,
// as it breaks if not running through the bundler
export const legacyStrings = {
  Label_BillingAddress: _TL_('Billing address'),
  AddressControl_AddressLine1: _TL_('Address line 1'),
  AddressControl_AddressLine2: _TL_('Address line 2'),
  AddressControl_City: _TL_('City'),
  AddressControl_StateOrProvince: _TL_('State or province'),
  AddressControl_State: _TL_('State'),
  AddressControl_Province: _TL_('Province'),
  AddressControl_ZipCode: _TL_('ZIP code'),
  AddressControl_PostalCode: _TL_('Postal code'),
  AddressControl_ZipOrPostalCode: _TL_('ZIP or Postal code'),
  Validation_NotEmpty_Required_Field: _TL_('This field is required'),
  Validation_String_Max_Length: _TL_('Field should not exceed {{maxlength}} characters'),
  Validation_String_Invalid_Characters: _TL_('Enter a valid value'),
  AddressControl_AddressLine3: _TL_('Address line 3'),
  AddressControl_AddressLine4: _TL_('Address line 4'),
  AddressControl_ProvinceOrRegion: _TL_('Province or region'),
  AddressControl_Country: _TL_('Country or region'),
};

export type LegacyStrings = typeof legacyStrings;
